import React, { useState, useContext, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { ColorModeContext } from '../../assets/theme/color-context';
import makeStyles from "@material-ui/styles/makeStyles";
import moment from 'moment';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Container,
  Avatar,
  Button,
  Grid,
  MenuItem,
  Badge,
  Drawer,
  Link,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Modal,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CardHeader,
  Divider,
  Switch,
  FormControlLabel,
  Stack,
  Tooltip
} from '@mui/material';
import { toast } from 'react-toastify';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuIcon from '@mui/icons-material/Menu';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ErrorIcon from '@mui/icons-material/Error';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
// import DynamicFormIcon from '@mui/icons-material/DynamicForm';

import OnboardPreview from "../../pages/onboard/OnboardPreview";
import UserMember from './UserMember';

import ToastMessage from "./ToastMessage";
import IMG_LOGO from "../../assets/img/logo.png";
import IMG_LOGO_DARK from "../../assets/img/logo-sticky.png";
import patternImage from "../../assets/img/pattern-1.jpg";
import {ReactComponent as MailIcon} from '../../assets/svg/mail.svg';
import {ReactComponent as BookingsIcon} from '../../assets/svg/bookings.svg';
import {ReactComponent as FlareIcon} from '../../assets/svg/flare.svg';
import {ReactComponent as ContentCopyIcon} from '../../assets/svg/contentcopy.svg';
import {ReactComponent as NotificationIcon} from '../../assets/svg/notification.svg';
import {ReactComponent as CalendarIcon} from '../../assets/svg/calendar.svg';
import {ReactComponent as SunIcon} from '../../assets/svg/sun.svg';
import {ReactComponent as MoonIcon} from '../../assets/svg/moon.svg';
import {ReactComponent as PerksIcon} from '../../assets/svg/perks.svg';
import {ReactComponent as PreviewIcon} from '../../assets/svg/preview.svg';
import {ReactComponent as CustomizeIcon} from '../../assets/svg/customize.svg';
import {ReactComponent as OnboardIcon} from '../../assets/svg/onboard.svg';
import {ReactComponent as EmbedIcon} from '../../assets/svg/embed.svg';
import {ReactComponent as HelpIcon} from '../../assets/svg/help.svg';
import {ReactComponent as ContactIcon} from '../../assets/svg/contact.svg';

import { useDispatch, useSelector } from 'react-redux';
import { loadUser, logout, readNotification } from '../../redux/actions/auth';
import { getBookingFormData } from "../../redux/actions/book";
import config from "../../config/config";

import {
  DASHBOARD_MENU,
  THEME_MENU,
  USER_PROFILE_MENU,
  USER_SUB_MENU,
  MY_BOOKING_MENU,
  BOOKING_FORM,
  ONBOARD_FORM,
  NOTIFICATION_MENU
} from '../../utils/constants';
import { socketIo } from '../..';
import { getBookingData } from '../../redux/actions/book';

const EXCHANGE_POSITION = 350;

function Navbar() {
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const [anchorSidebar, setAnchorSidebar] = useState(false);
  const [anchorDropdownMenu, setAnchorDropdownMenu] = useState(null);
  const [anchorUserMenu, setAnchorUserMenu] = useState(null);
  const [anchorSubscriptionMenu, setAnchorSubscriptionMenu] = useState(null);
  const [anchorThemeMenu, setAnchorThemeMenu] = useState(null);
  const [subpageItems, setSubpageItems] = useState([]);
  const [subpageTypeMenu, setSubpageTypeMenu] = useState();
  const [anchorNotification, setAnchorNotification] = useState(null);
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [scrollNavBar, setScrollNavBar] = useState(false);

  const { user, notification, unreadNum, emailNotification } = useSelector(state => ({
    user: state.auth.user,
    notification: state.auth.notification,
    unreadNum: state.auth.unreadNum,
    emailNotification: state.book.emailNotification,
  }));

  const onChangeNavBar = () => setScrollNavBar(window.scrollY >= EXCHANGE_POSITION);

  const pagesList = [
    {
      page: { title: 'Dashboard', href: '/dashboard' },
      subpages: [],
      typeMenu: DASHBOARD_MENU
    },
    {
      page: { title: 'Manage Bookings', href: '' },
      subpages: [
        {
          title: 'View All Bookings',
          href: '/bookings',
          tip: 'View all client bookings \nsubmitted through your form.',
          icon: <BookingsIcon color={theme.palette.mode === 'light' ? '#5e6278' : '#90929f'} style={{ width: '18px', height: '18px' }} />
        },
        {
          title: 'Edit Notifications',
          href: '/bookings/edit-notifications',
          tip: 'Personalize emails sent to\nclients.',
          icon: <MailIcon color={theme.palette.mode === 'light' ? '#5e6278' : '#90929f'} style={{ width: '18px', height: '18px' }} />
        },
      ],
      typeMenu: MY_BOOKING_MENU
    },
    {
      page: { title: 'Reservation Form', href: '' },
      subpages: [
        {
          title: 'Customize Form',
          href: '/bookings/customize-form',
          tip: 'Customize your personal\nbooking form.',
          icon: <CustomizeIcon color={theme.palette.mode === 'light' ? '#5e6278' : '#90929f'} style={{ width: '18px', height: '18px' }} />
        },
        {
          title: 'Get Embed Code',
          href: '/bookings/embed',
          tip: 'Get the embed code for your\nbooking form.',
          icon: <EmbedIcon color={theme.palette.mode === 'light' ? '#5e6278' : '#90929f'} style={{ width: '18px', height: '18px' }} />
        },
        {
          title: 'Preview Booking',
          tip: 'Preview your booking form',
          icon: <PreviewIcon color={theme.palette.mode === 'light' ? '#5e6278' : '#90929f'} style={{ width: '18px', height: '18px' }} />
        },
      ],
      typeMenu: BOOKING_FORM
    },
    {
      page: { title: 'Date Onboarding', href: '' },
      subpages: [
        {
          title: 'Date Onboarding',
          href: '/onboard/form',
          tip: 'Customize your onboarding\nwelcome pack.',
          icon: <OnboardIcon color={theme.palette.mode === 'light' ? '#5e6278' : '#90929f'} style={{ width: '18px', height: '18px' }} />
        },
        {
          title: 'Preview Pack',
          tip: 'Preview welcome pack.',
          icon: <PreviewIcon color={theme.palette.mode === 'light' ? '#5e6278' : '#90929f'} style={{ width: '18px', height: '18px' }} />
        },
      ],
      typeMenu: ONBOARD_FORM
    },
    {
      page: { title: 'Loyalty Perks', href: '' },
      subpages: [
        {
          title: 'View All Perks',
          href: '/perks/perks-admin',
          tip: 'View all your active perks.',
          icon: <PerksIcon color={theme.palette.mode === 'light' ? '#5e6278' : '#90929f'} style={{ width: '18px', height: '18px' }} />
        },
        {
          title: 'Customize',
          href: '/perks/perks-customize',
          tip: 'Customize your Perks page.',
          icon: <CustomizeIcon color={theme.palette.mode === 'light' ? '#5e6278' : '#90929f'} style={{ width: '18px', height: '18px' }} />
        },
        {
          title: 'Preview Perks',
          href: `/${user?.username}/perks`,
          tip: 'Preview your Perks page.',
          icon: <PreviewIcon color={theme.palette.mode === 'light' ? '#5e6278' : '#90929f'} style={{ width: '18px', height: '18px' }} />
        },
      ],
      typeMenu: ONBOARD_FORM
    },
    {
      page: { title: 'Help', href: '' },
      subpages: [
        {
          title: 'Getting Started',
          href: '/help/faq',
          tip: 'Let us help with any\nquestions!',
          icon: <HelpIcon color={theme.palette.mode === 'light' ? '#5e6278' : '#90929f'} style={{ width: '18px', height: '18px' }} />
        },
        {
          title: 'Contact Us',
          tip: 'Get in touch with the Clientl\nsupport team.',
          href: '/help/contact',
          icon: <ContactIcon color={theme.palette.mode === 'light' ? '#5e6278' : '#90929f'} style={{ width: '18px', height: '18px' }} />
        },
      ],
      typeMenu: ONBOARD_FORM
    }
  ];

  const subscriptionPages = [
    { title: 'Referrals', href: '' },
    { title: 'Billing', href: '' },
    { title: 'Payments', href: '' },
    { title: 'Statements', href: '' }
  ];

  const useStyles = makeStyles({
    appearanceModePaper: {
      padding: '0px 10px',
    },
    appearanceModeSelected: {
      backgroundColor: theme.palette.mode === 'light' ? '#f4f6fa !important' : '#2b2b40 !important',
      borderRadius: '6px',
    },
    paper: {
      padding: '8px 14px',
      borderRadius: '6px',
    },
    popOverRoot: {
      pointerEvents: "none"
    },
    title: {
      color: theme.palette.mode === 'light' ? '#111111' : '#cdcdde',
      fontSize: '0.82rem',
      fontWeight: '500',
      lineHeight: '20px',
      letterSpacing: '-0.2px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      '&:hover': {
        color: '#009ef7 !important',
      }
    },
    subheader: {
      color: theme.palette.mode === 'light' ? '#a1a1a1' : '#474761',
      fontSize: '0.74rem',
      fontWeight: '400',
      lineHeight: '19px',
    },
    content: {
      maxWidth: '200px'
    }
  });
  const styles = useStyles();
  let currentlyHovering = false;

  const handleChange = (panel, page) => (event, isExpanded) => {
    if (page.page.href) {
      navigate(page.page.href);
      handleOpenSidebar(false)();
    }
    setExpanded(isExpanded ? panel : false);
  };

  const handleOpenSidebar = (open) => () => {
    setAnchorSidebar(open);
  };

  function handleClick(event, typeMenu, subPageContent) {
    if (event.type === 'click' && typeMenu === DASHBOARD_MENU) {
      navigate('/dashboard');
      return;
    }
    if (subPageContent) {
      setSubpageItems(subPageContent);
      setSubpageTypeMenu(typeMenu);
    }
    if (anchorThemeMenu !== event.currentTarget) {
      switch (typeMenu) {
        case THEME_MENU:
          setAnchorThemeMenu(event.currentTarget);
          break;
        case USER_PROFILE_MENU:
          setAnchorUserMenu(event.currentTarget);
          break;
        case USER_SUB_MENU:
          setAnchorSubscriptionMenu(event.currentTarget);
          break;
        case MY_BOOKING_MENU:
        case BOOKING_FORM:
        case ONBOARD_FORM:
          setAnchorDropdownMenu(event.currentTarget);
          break;
        case NOTIFICATION_MENU:
          setAnchorNotification(event.currentTarget);
          break;
        default:
          break;
      }
    }
  }

  function handleHover() {
    currentlyHovering = true;
  }

  const handleClose = (typeMenu) => () => {
    switch (typeMenu) {
      case THEME_MENU:
        setAnchorThemeMenu(null);
        break;
      case USER_PROFILE_MENU:
        setAnchorUserMenu(null);
        break;
      case USER_SUB_MENU:
        setAnchorSubscriptionMenu(null);
        break;
      case MY_BOOKING_MENU:
      case BOOKING_FORM:
      case ONBOARD_FORM:
        setAnchorDropdownMenu(null);
        break;
      case NOTIFICATION_MENU:
        setAnchorNotification(null);
        dispatch(readNotification());
      default:
        break;
    }
  }

  const handleCloseHover = (typeMenu) => () => {
    currentlyHovering = false;
    setTimeout(() => {
      if (!currentlyHovering) {
        handleClose(typeMenu)();
      }
    }, 50);
  }

  let popupWindow = null;
  
  const centeredPopup = (url,winName,w,h,scroll) => {
    let LeftPosition = (window.innerWidth) ? (window.innerWidth-w)/2 : 0;
    let TopPosition = (window.innerHeight) ? (window.innerHeight-h)/2 : 0;
    let settings = 'height='+h+',width='+w+',top='+TopPosition+',left='+LeftPosition+',location=1, status=1, scrollbars='+scroll+',resizable'
    popupWindow = window.open(url,winName,settings)
  }

  const onClickMenuItem = (subpage) => {
    if (subpage.title === 'Preview Pack') {
      dispatch(getBookingFormData(user?.bookFormId));
      setPreviewModalVisible(true);
    } else if (subpage.title === 'Preview Booking') {
      centeredPopup(`${config.CLIENT_BASE_URL}/${user?.username}/book`, "mywindow", 1400, 880, 1)
    }
    setAnchorDropdownMenu(null);
  }

  const onMyProfile = () => {
    setAnchorUserMenu(null);
    navigate("/account-settings/profile");
  };

  const onFormSettings = () => {
    setAnchorUserMenu(null);
    navigate("/account-settings/form");
  }

  const onMyMembership = () => {
    setAnchorUserMenu(null);
    navigate("/account-settings/membership");
  };

  const onMyPassword = () => {
    setAnchorUserMenu(null);
    navigate("/account-settings/password");
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
  }

  const onMobileLink = async (subpage) => {
    if (subpage.title === 'Preview Pack') {
      await dispatch(getBookingFormData(user?.bookFormId));
      setPreviewModalVisible(true);
    } else if (subpage.title === 'Preview Booking') {
      
      centeredPopup(`${config.CLIENT_BASE_URL}/${user?.username}/book`, "mywindow", 1400, 880, 1)
    }
    handleOpenSidebar(false)();
  }

  useEffect(() => {
    socketIo.on('SET_SOCKET_REQUEST', () => {
      socketIo.emit('SET_SOCKET_ID', { user_id: user?.id || "" })
    })
    socketIo.on('MAIL_RECEIVED_NOTIFICATION', () => {
      // api request
      dispatch(loadUser());
      dispatch(getBookingData());
      dispatch(getBookingFormData(user?.bookFormId));
    });
    socketIo.on('WELCOME_PACK_EMAIL_OPENED', (arg) => {
      toast(<ToastMessage title="Just letting you know..." message={`${arg} has received and viewed your Welcome Pack.`} />, { closeButton: false });
    });

    window.addEventListener('scroll', onChangeNavBar);
    return () => window.removeEventListener('scroll', onChangeNavBar);
  }, []);

  return (
    <AppBar
      position={scrollNavBar ? "sticky" : "static"}
      sx={{ borderBottom: { md: '1px solid rgba(255, 255, 255, 0.1)', sm: 'none' }, boxShadow: scrollNavBar ? 1 : 0 }}
      style={{ background: scrollNavBar ? theme.palette.mode === 'light' ? '#fff' : '#1e1e2d' : 'transparent' }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters>

          {/* logo title when more than xs */}
          <Link href='/bookings'>
            <Box
              component="img"
              sx={{ width: 100, display: { xs: 'none', md: 'flex' } }}
              src={scrollNavBar ? theme.palette.mode === 'light' ? IMG_LOGO_DARK : IMG_LOGO : IMG_LOGO}
              alt="logo"
            />
          </Link>

          {/* collapse icon */}
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenSidebar(true)}
              color="inherit"
              sx={{
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
            >
              <MenuIcon sx={{ color: scrollNavBar ? theme.palette.mode === 'light' ? '#000' : '#fff' : '#fff' }} />
            </IconButton>
          </Box>

          {/* logo title when less than md */}
          <Box
            component="img"
            sx={{ width: 100, display: { xs: 'flex', md: 'none' } }}
            src={scrollNavBar ? theme.palette.mode === 'light' ? IMG_LOGO_DARK : IMG_LOGO : IMG_LOGO}
            alt="logo"
          />

          {/* item title navbar */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: 'none', md: 'flex' },
              marginInlineStart: 5
            }}
          >
            {pagesList.map((page, index) => (
              <div key={index}>
                <Button
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  sx={{
                    my: 2,
                    padding: '10px 13px',
                    marginInlineStart: 1,
                    borderRadius: '6px',
                    backgroundColor: [...page.subpages.map(e => e.href), page.page.href].includes(location.pathname) ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
                    color: scrollNavBar ? theme.palette.mode === 'light' ? '#252525' : '#ffffff' : 'white',
                    display: 'block',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '13px',
                    '&:hover': {
                      color: scrollNavBar && '#009ef7',
                      backgroundColor: scrollNavBar ? 'transparent' : 'rgba(255, 255, 255, 0.1)'
                    }
                  }}
                  onClick={(e) => handleClick(e, page.typeMenu, page.subpages)}
                  onMouseOver={(e) => {handleClick(e, page.typeMenu, page.subpages);  handleHover();}}
                  onMouseLeave={handleCloseHover(page.typeMenu)}
                >
                  {page.page.title}
                </Button>
              </div>
            ))}
            {/* item title dropdown list */}
            {subpageItems.length > 0 &&
              <Menu
                id="menu-appbar"
                anchorEl={anchorDropdownMenu}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorDropdownMenu)}
                onClose={handleClose(subpageTypeMenu)}
                MenuListProps={{
                  onMouseEnter: handleHover,
                  onMouseLeave: handleCloseHover(subpageTypeMenu),
                  style: { pointerEvents: "auto" }
                }}
                PopoverClasses={{
                  paper: styles.paper,
                  root: styles.popOverRoot
                }}
              >
                {subpageItems.map((subpage) => (
                  <Tooltip key={subpage.title} title={subpage.tip} placement="right" enterTouchDelay={0}>
                    <Link href={subpage.href}>
                      <MenuItem
                        display="flex"
                        onClick={() => onClickMenuItem(subpage)}
                        sx={{
                          px: '13px',
                          py: '10px',
                          fontSize: '13px',
                          fontWeight: 500,
                          alignItems: 'center',
                          "&:hover": {
                            color: '#009ef7',
                          },
                          '&:hover svg': {
                            color: '#009ef7',
                          },
                        }}
                      >
                        {subpage.icon}&nbsp;&nbsp;{subpage.title}
                      </MenuItem>
                    </Link>
                  </Tooltip>
                ))}
              </Menu>}
          </Box>

          {/* icon list on navbar */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flex: 1 }}>
            <IconButton
              aria-label="show 4 new mails"
              onClick={(e) => handleClick(e, NOTIFICATION_MENU)}
              sx={{
                width: '40px',
                height: '40px',
                "&:hover": {
                  backgroundColor: scrollNavBar ? theme.palette.mode === 'light' ? '#f1faff' : '#212e48' : 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '6px',
                },
                "&:hover svg": {
                  color: scrollNavBar && '#009ef7',
                },
              }}
            >
              <Badge
                badgeContent={unreadNum}
                sx={{
                  "& .MuiBadge-badge": {
                    color: "#fff",
                    backgroundColor: "#009EF7"
                  }
                }}>
                <NotificationIcon color={scrollNavBar ? theme.palette.mode ? '#a1a5b7' : '#565674' : '#fff'} />
              </Badge>
            </IconButton>
            {/* notification dropdown */}
            <Menu
              sx={{ mt: '40px' }}
              anchorEl={anchorNotification}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorNotification)}
              onClose={handleClose(NOTIFICATION_MENU)}
              PaperProps={{
                sx: {
                  width: '400px',
                  ".MuiList-root": { padding: '0!important' }
                },
              }}
            >
              <MenuItem
                sx={{
                  py: 2.5,
                  backgroundImage: `url(${patternImage})`,
                  backgroundRepeat: 'no-repeat'
                }}
              >
                <Typography sx={{ color: 'white', fontSize: '1.125rem', fontWeight: 700, marginInlineStart: 2 }}>Notifications</Typography>
              </MenuItem>
              <Box margin="20px 6px">
                {notification?.length > 0
                  ? notification?.map((note, index) =>
                    <MenuItem
                      key={index}
                      sx={{ py: 1.5 }}
                    >
                      <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{ width: '100%' }}>
                        <CardHeader
                          classes={{ title: styles.title, subheader: styles.subheader, content: styles.content }}
                          avatar={
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              sx={{ backgroundColor: theme.palette.mode === 'light' ? '#e8fff3' : '#1c3238', borderRadius: '6px', width: '35px', height: '35px' }}
                            >
                              <CalendarIcon color="#50cd89" style={{ width: '21px', height: '21px' }} />
                            </Box>
                          }
                          title={note?.title ? note.title : `New Booking: ${note?.bookingId?.fullName}`}
                          subheader={note?.message ? note.message : `Submitted ${moment(note?.createdAt).format('DD MMM')} at ${moment(note?.createdAt).format('LT')}`}
                          subheaderTypographyProps={{ color: note?.isRead ?? '#ccc' }}
                          sx={{ padding: 0, color: note?.isRead ? '#ccc' : '#212121', backgroundColor: theme.palette.mode === 'dark' && '#1e1e2d' }}
                        />
                        <Typography
                          sx={{
                            backgroundColor: theme.palette.mode === 'light' ? '#f5f8fa' : '#2b2b40',
                            color: theme.palette.mode === 'light' ? '#7e8299' : '#6d6dd0',
                            fontSize: '0.6rem',
                            borderRadius: '5.5px',
                            padding: '8px 10px',
                            fontWeight: 500,
                          }}
                        >
                          {moment(note?.createdAt).fromNow(true)} ago
                        </Typography>
                      </Stack>
                    </MenuItem>
                  )
                  : <MenuItem
                    sx={{ py: 1.5 }}
                  >
                    <Typography textAlign="center" sx={{ color: theme.palette.mode === 'light' && 'black', fontSize: '0.8rem', fontWeight: 600, marginInlineStart: 2 }}>No notifications yet</Typography>
                  </MenuItem>
                }
              </Box>
            </Menu>

            <IconButton
              onClick={(e) => handleClick(e, THEME_MENU)}
              onMouseOver={(e) => handleClick(e, THEME_MENU)}
              onMouseLeave={handleCloseHover(THEME_MENU)}
              sx={{
                marginLeft: '10px',
                width: '40px',
                height: '40px',
                "&:hover": {
                  backgroundColor: scrollNavBar ? theme.palette.mode === 'light' ? '#f1faff' : '#212e48' : 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '6px',
                },
                "&:hover svg": {
                  color: scrollNavBar && '#009ef7',
                }
              }}
            >
              {theme.palette.mode === 'light' ? 
                <SunIcon color={scrollNavBar ? theme.palette.mode ? '#a1a5b7' : '#565674' : '#fff'} /> : 
                <MoonIcon color={scrollNavBar ? theme.palette.mode ? '#a1a5b7' : '#565674' : '#fff'} />
              }
            </IconButton>
            {/* Light & Dark theme picker dropdown */}
            <Menu
              sx={{ mt: '40px' }}
              anchorEl={anchorThemeMenu}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorThemeMenu)}
              onClose={handleClose(THEME_MENU)}
              MenuListProps={{
                onMouseEnter: handleHover,
                onMouseLeave: handleCloseHover(THEME_MENU),
                style: { pointerEvents: "auto" }
              }}
              PopoverClasses={{
                root: styles.popOverRoot,
                paper: styles.appearanceModePaper
              }}
              PaperProps={{ sx: { minWidth: '150px' } }}
            >
              <MenuItem
                selected={theme.palette.mode === 'light'}
                classes={{ selected: styles.appearanceModeSelected }}
                sx={{
                  my: '3px',
                  alignItems: 'center',
                  padding: '7px 10px',
                  "&:hover svg": {
                    color: '#009ef7',
                  },
                  "&:hover p": {
                    color: '#009ef7',
                  },
                }}
                onClick={() => {
                  colorMode.setLightMode();
                  setAnchorThemeMenu(null);
                }}
              >
                <SunIcon color={theme.palette.mode === 'light' ? '#009ef7' : '#565674'} style={{ width: '18px', height: '18px' }} />
                <Typography
                  textAlign="center"
                  sx={{
                    color: theme.palette.mode === 'light' ? '#009ef7' : '#92929f',
                    fontSize: '13px',
                    fontWeight: 500,
                    marginInlineStart: 2
                  }}
                >
                  Light
                </Typography>
              </MenuItem>
              <MenuItem
                selected={theme.palette.mode === 'dark'}
                classes={{ selected: styles.appearanceModeSelected }}
                sx={{
                  my: '3px',
                  alignItems: 'center',
                  padding: '7px 10px',
                  "&:hover svg": {
                    color: '#009ef7',
                  },
                  "&:hover p": {
                    color: '#009ef7',
                  },
                }}
                onClick={() => {
                  colorMode.setDarkMode();
                  setAnchorThemeMenu(null);
                }}
              >
                <MoonIcon color={theme.palette.mode === 'light' ? '#A1A5B7' : '#009ef7'} style={{ width: '18px', height: '18px' }} />
                <Typography
                  textAlign="center"
                  sx={{
                    color: theme.palette.mode === 'light' ? '#5e6278' : '#009ef7',
                    fontSize: '13px',
                    fontWeight: 500,
                    marginInlineStart: 2
                  }}
                >
                  Dark
                </Typography>
              </MenuItem>
            </Menu>

            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar1"
              aria-haspopup="true"
              sx={{
                px: 0,
                marginLeft: '10px',
                width: '40px',
                height: '40px',
                "&:hover": {
                  backgroundColor: scrollNavBar ? theme.palette.mode === 'light' ? '#f1faff' : '#212e48' : 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '6px',
                },
                "&:hover svg": {
                  color: scrollNavBar && '#009ef7',
                }
              }}
              onClick={(e) => handleClick(e, USER_PROFILE_MENU)}
              onMouseOver={(e) => handleClick(e, USER_PROFILE_MENU)}
              onMouseLeave={handleCloseHover(USER_PROFILE_MENU)}
            >
              {user == null || user?.avatar?.includes("https://gravatar.com/") ?
                <Avatar sx={{ bgcolor: 'tomato', width: '2rem', height: '2rem' }} alt="User Name" variant='rounded'>
                  {user?.firstName[0]}
                </Avatar> :
                <Box
                  component="img"
                  src={`${config.SERVER_BASE_URL}/${user.avatarThumbnail}`}
                  alt="avatarThumbnail"
                  style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    transform: 'translate3d(0, 0, 1px)',
                  }}
                />
              }
            </IconButton>
            {/* User profile */}
            <Menu
              sx={{ mt: '40px' }}
              id="menu-appbar-client-profile"
              anchorEl={anchorUserMenu}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorUserMenu)}
              onClose={handleClose(USER_PROFILE_MENU)}
              PaperProps={{ sx: { minWidth: '250px', borderRadius: '10px' } }}
              MenuListProps={{
                onMouseEnter: handleHover,
                onMouseLeave: handleCloseHover(USER_PROFILE_MENU),
                style: { pointerEvents: "auto" }
              }}
              PopoverClasses={{
                root: styles.popOverRoot
              }}
            >
              <MenuItem>
                <CardHeader
                  avatar={
                    user == null || user?.avatar?.includes("https://gravatar.com/") ?
                      <Avatar sx={{ bgcolor: 'tomato' }} aria-label="recipe" variant='rounded'>
                        {user?.firstName[0]}
                      </Avatar> :
                      <Box
                        component="img"
                        src={`${config.SERVER_BASE_URL}/${user.avatarThumbnail}`}
                        alt="avatarThumbnail"
                        style={{
                          width: '45px',
                          height: '45px',
                          borderRadius: '50%',
                          objectFit: 'cover',
                          transform: 'translate3d(0, 0, 1px)',
                        }}
                      />
                  }
                  title={
                    <Box display="flex" alignItems="center">
                      <div style={{ fontSize: '0.95rem', fontWeight:600, lineHeight: '16px' }}>{user?.fullName}</div>
                      <Grid sx={{ fontSize: '14px',fontWeight: 600, textAlign: 'center', ml: 1 }}>
                        <UserMember />
                      </Grid>
                    </Box>
                  }
                  subheader={<div style={{ fontSize: '11px', fontWeight:300, lineHeight: '13px' }}>{user?.email}</div>}
                  sx={{ color: '#212121', padding: 0, backgroundColor: theme.palette.mode === 'dark' && '#1e1e2d' }}
                />
              </MenuItem>
              <Divider />
              <MenuItem
                onClick={onMyProfile}
                sx={{
                  py: 1,
                  marginX: 2,
                  marginY: 0.5,
                  "&:hover": {
                    backgroundColor: theme.palette.mode === 'light' ? '#f4f6fa' : '#2b2b40',
                    borderRadius: '6px',
                  },
                  "&:hover p": {
                    color: '#009ef7',
                  },
                }}
              >
                <Typography
                  textAlign="center"
                  sx={{
                    fontSize: '0.85rem',
                    fontWeight: 500,
                    color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde',
                  }}
                >
                  My Profile
                </Typography>
              </MenuItem>
              <MenuItem
                onClick={onFormSettings}
                sx={{
                  py: 1,
                  marginX: 2,
                  marginY: 0.5,
                  "&:hover": {
                    backgroundColor: theme.palette.mode === 'light' ? '#f4f6fa' : '#2b2b40',
                    borderRadius: '6px',
                  },
                  "&:hover p": {
                    color: '#009ef7',
                  },
                }}
              >
                <Typography
                  textAlign="center"
                  sx={{
                    fontSize: '0.85rem',
                    fontWeight: 500,
                    color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde',
                  }}
                >
                  Form Settings
                </Typography>
              </MenuItem>
              <MenuItem
                onClick={onMyMembership}
                sx={{
                  py: 1,
                  marginX: 2,
                  marginY: 0.5,
                  "&:hover": {
                    backgroundColor: theme.palette.mode === 'light' ? '#f4f6fa' : '#2b2b40',
                    borderRadius: '6px',
                  },
                  "&:hover p": {
                    color: '#009ef7',
                  },
                }}
              >
                <Typography
                  textAlign="center"
                  sx={{
                    fontSize: '0.85rem',
                    fontWeight: 500,
                    color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde',
                  }}
                >
                  My Membership
                </Typography>
              </MenuItem>
              <MenuItem
                onClick={onMyPassword}
                sx={{
                  py: 1,
                  marginX: 2,
                  marginY: 0.5,
                  "&:hover": {
                    backgroundColor: theme.palette.mode === 'light' ? '#f4f6fa' : '#2b2b40',
                    borderRadius: '6px',
                  },
                  "&:hover p": {
                    color: '#009ef7',
                  },
                }}
              >
                <Typography
                  textAlign="center"
                  sx={{
                    fontSize: '0.85rem',
                    fontWeight: 500,
                    color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde',
                  }}
                >
                  My Password
                </Typography>
              </MenuItem>
              {/* <MenuItem
                sx={{ py: 1.5, marginInlineStart: 1 }}
                // onClick={(e) => handleClick(e, USER_SUB_MENU)}
                onMouseOver={(e) => handleClick(e, USER_SUB_MENU)}
                onMouseLeave={handleCloseHover(USER_SUB_MENU)}
              >
                <Typography textAlign="center" sx={{ fontSize: '0.8rem', fontWeight: 600, color: theme.palette.mode === 'light' && 'black' }}>My Subscription</Typography>
                <ListItemIcon sx={{ minWidth: '0!important', marginInlineStart: 'auto' }}>
                  <NavigateNextIcon />
                </ListItemIcon>
              </MenuItem> */}
              <Divider />
              {/* <MenuItem onClick={() => setAnchorUserMenu(null)} sx={{ py: 1.5, marginInlineStart: 1 }}>
                <Typography textAlign="center" sx={{ fontSize: '0.8rem', fontWeight: 600, color: theme.palette.mode === 'light' && 'black' }}>Account Setting</Typography>
              </MenuItem> */}
              <MenuItem
                onClick={handleLogout}
                sx={{
                  py: 1,
                  marginX: 1,
                  "&:hover": {
                    backgroundColor: theme.palette.mode === 'light' ? '#f4f6fa' : '#2b2b40',
                    borderRadius: '6px',
                  },
                  "&:hover p": {
                    color: '#009ef7',
                  },
                }}
              >
                <Typography
                  textAlign="center"
                  sx={{
                    fontSize: '13px',
                    fontWeight: 500,
                    color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde',
                  }}
                >
                  Sign Out
                </Typography>
              </MenuItem>
            </Menu>
            {/* User subscription sub Dropdown menu */}
            <Menu
              id="menu-appbar-subscription"
              anchorEl={anchorSubscriptionMenu}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorSubscriptionMenu)}
              onClose={handleClose(USER_SUB_MENU)}
              MenuListProps={{
                onMouseEnter: handleHover,
                onMouseLeave: () => {
                  handleCloseHover(USER_SUB_MENU)();
                  handleCloseHover(USER_PROFILE_MENU)();
                },
                style: { pointerEvents: "auto" }
              }}
              PopoverClasses={{
                root: styles.popOverRoot
              }}
              style={{ // Add here you negative margin
                marginInlineStart: '-208px'
              }}
              PaperProps={{ sx: { width: '200px' } }}
            >
              {subscriptionPages.map((page) => (
                <MenuItem key={page.title} sx={{ py: 1.5, marginInlineStart: 1 }} onClick={() => { setAnchorSubscriptionMenu(null); setAnchorUserMenu(null) }}>
                  <Typography textAlign="center" sx={{ fontSize: '0.8rem', fontWeight: 600, color: theme.palette.mode === 'light' && 'black' }}>{page.title}</Typography>
                  {page.title === 'Statements' && <ListItemIcon sx={{ minWidth: '0!important', marginInlineStart: 'auto' }}>
                    <ErrorIcon fontSize="small" />
                  </ListItemIcon>}
                </MenuItem>
              ))}
              <Divider />
              <MenuItem>
                <FormControlLabel
                  control={<Switch defaultChecked />}
                  label={'Notification'}
                  sx={{
                    '.MuiFormControlLabel-label': {
                      marginInlineStart: 1,
                      fontSize: '0.8rem',
                      fontWeight: 600,
                      opacity: 0.6,
                      color: theme.palette.mode === 'light' && 'black'
                    }
                  }}
                />

              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>

        {/* side bar */}
        <Drawer
          anchor={'left'}
          open={anchorSidebar}
          onClose={handleOpenSidebar(false)}
        >
          <Box
            sx={{ padding: '40px 32px 0 32px' }}
            role="presentation"
            // onClick={handleOpenSidebar(false)}
            onKeyDown={handleOpenSidebar(false)}
          >
            {pagesList.map((page, index) => (
              <Accordion key={index} expanded={expanded === `panel${index}`} onChange={handleChange(`panel${index}`, page)} sx={{ boxShadow: 'none', '&:before': { display: 'none' } }} disableGutters>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${index}bh-content`}
                  id={`panel${index}bh-header`}
                >
                  <Typography
                    // color='primary'
                    sx={{
                      flexShrink: 0,
                      fontSize: '0.8rem',
                      fontWeight: 600,
                      color: theme.palette.mode === 'light' && '#5E6278'
                    }}
                  >
                    {page.page.title}
                  </Typography>
                </AccordionSummary>
                {page.subpages.length > 0 && <AccordionDetails>
                  {page.subpages.map((subpage, index) => (
                    <ListItem key={subpage.title} disablePadding>
                      <Link href={subpage.href} onClick={() => onMobileLink(subpage)}>
                        <ListItemButton>
                          <ListItemIcon>
                            {subpage.icon}
                          </ListItemIcon>
                          <ListItemText primary={subpage.title} primaryTypographyProps={{ fontSize: '0.8rem', color: theme.palette.mode === 'light' && '#5E6278' }} />
                        </ListItemButton>
                      </Link>
                    </ListItem>
                  ))}
                </AccordionDetails>}
              </Accordion>
            ))}
          </Box>
        </Drawer>
      </Container>
      <Modal
        open={previewModalVisible}
        onClose={() => setPreviewModalVisible(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '24px',
            maxHeight: '95%',
            overflowY: 'auto',
            '::-webkit-scrollbar': {
              width: '12px',
            },
            '::-webkit-scrollbar-track': {
              backgroundColor: 'transparent',
            },
            '::-webkit-scrollbar-thumb': {
              borderRadius: '6px',
              border: '3px solid transparent',
              backgroundClip: 'content-box',
              backgroundColor: '#c1c1c1',
            }
          }}
        >
          <OnboardPreview
            onboardTemplate={emailNotification.onboardTemplate}
            onboardCompanyLogo={emailNotification.companyLogo}
            onboardHeadingTitle={emailNotification?.onboardHeadingTitle}
            onboardHeadingMessage={emailNotification?.onboardHeadingMessage?.replace(/{client_fname}/g, user?.firstName)}
            onboardHeadingEnableDate={emailNotification?.onboardHeadingEnableDate}
            onboardSection1Enable={emailNotification?.onboardSection1Enable}
            onboardSection1Image={emailNotification?.onboardSection1Image}
            onboardSection1ImageSelected={emailNotification?.onboardSection1ImageSelected}
            onboardSection1Heading={emailNotification?.onboardSection1Heading}
            onboardSection1Content={emailNotification?.onboardSection1Content}
            onboardSection2Enable={emailNotification?.onboardSection2Enable}
            onboardSection2Image={emailNotification?.onboardSection2Image}
            onboardSection2ImageSelected={emailNotification?.onboardSection2ImageSelected}
            onboardSection2Heading={emailNotification?.onboardSection2Heading}
            onboardSection2Content={emailNotification?.onboardSection2Content}
            onboardSection3Enable={emailNotification?.onboardSection3Enable}
            onboardSection3Image={emailNotification?.onboardSection3Image}
            onboardSection3ImageSelected={emailNotification?.onboardSection3ImageSelected}
            onboardSection3Heading={emailNotification?.onboardSection3Heading}
            onboardSection3Content={emailNotification?.onboardSection3Content}
            onboardFooterHeading={emailNotification?.onboardFooterHeading}
            onboardFooterContent={emailNotification?.onboardFooterContent}
          />
        </Box>
      </Modal>
    </AppBar>
  );
}

export default Navbar;
